<template>
  <section class="main-box">
    <el-row>
      <el-col :span="24" class="q-title">
        <div class="q-title"><i></i>员工基本信息</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="q-mes">
        <el-row>
          <el-col :span="24" class="q-mes-f" style="text-align: center;padding-bottom: 15px;">
            <img :src="this.GLOBAL.basePhotoPath+this.formData.employeePhoto"  v-if="this.formData.employeePhoto!=null && this.formData.employeePhoto!=''"
                 width="100" height="100" align="center"/>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">姓名：{{this.formData.employeeName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">性别：{{this.formData.employeeGender==1?'男':'女'}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">身份证号：{{this.formData.employeeCode}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">家庭住址：{{this.formData.employeeAddr}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">联系电话：{{this.formData.employeeTel}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">岗位：{{this.formData.roleNames}}</el-col>
        </el-row>
      </el-col>
    </el-row>
  </section>
</template>

<script>
  import {userDetail} from '../../api/api'

  export default {
    name: "UserView",
    data() {
      return {
        detailId: null,
        formData:{},
      }
    },
    methods: {
      getURLParam: function (paraName) {
        var url = document.location.toString()
        var arrObj = url.split('?')
        if (arrObj.length > 1) {
          var arrPara = arrObj[1].split('&')
          var arr
          for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=')
            if (arr != null && arr[0] == paraName) {
              return arr[1]
            }
          }
          return ''
        } else {
          return ''
        }
      },
    },
    mounted() {
      this.detailId = this.getURLParam('id');
      userDetail({id: this.detailId}, this.GLOBAL.header).then(result => {
        if (result.success) {
          this.formData = result.data;
          console.log(this.formData);
        }
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/UserView.vue